module.exports = __webpack_public_path__ + "img/mash-hide.98561022.svg";